import styled from 'styled-components'

const Content = styled.div<TSFixMe>`
  padding: 35px 20px;
`

export const SitesSalesContent = (props: TSFixMe): TSFixMe => {
  return <Content>{props.children}</Content>
}
